/* eslint-disable no-undef, no-inner-declarations */
import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.min.css'
import 'nprogress/nprogress.css'
import '@/styluses/nprogress.styl'
import '@/styluses/main.styl'
import '@/styluses/bilife.styl'
import '@/styluses/process-icons.styl'
import '@/styluses/diagram.styl'
import '@/styluses/smart-app-banner.css'

import { i18n, getLocale } from '@/i18n'

import FileUploader from '@/components/utils/FileUploader/FileUploader'
import FileDownloader from '@/components/utils/FileDownloader/FileDownloader'
import DatePicker from '@/components/utils/DatePicker'
import MediaViewer from '@/components/utils/MediaViewer/MediaViewer'
import ProcessStartTemplate from '@/components/process/ProcessStartTemplate'
import ProcessInfoTemplate from '@/components/process/ProcessInfoTemplate'
import TaskTemplate from '@/components/task/TaskTemplate'

import VueMomentLib from 'vue-moment-lib'
import VueClipboard from 'vue-clipboard2'
import VueMask from 'v-mask'
import Vuetify from 'vuetify'
import Vue from 'vue'

import ru from 'vuetify/es5/locale/ru'
import en from 'vuetify/es5/locale/en'
import kk from '@/i18n/kk'

import store from '@/store'
import router from '@/router'
import { sync } from 'vuex-router-sync'
import rules from '@/utils/validationRules'
import App from '@/App'

import biTheme from '@/themes/bi_light'

// Android iOS Push Notifications
import devicePush from '@/services/device-push'

// Web Push Notifications
import webPush from '@/services/web-push'

// Service workers
/* eslint-disable import/no-webpack-loader-syntax */
import registerServiceWorker, { ServiceWorkerNoSupportError } from 'service-worker-loader!./sw/index'

sync(store, router)

VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)
Vue.use(Vuetify, {
  lang: {
    locales: { ru, en, kk },
    current: getLocale(),
  },
  theme: biTheme,
})
Vue.use(VueMomentLib)
Vue.use(VueMask)
Vue.component('wf-file-uploader', FileUploader)
Vue.component('wf-file-downloader', FileDownloader)
Vue.component('wf-date-picker', DatePicker)
Vue.component('wf-media-viewer', MediaViewer)
Vue.component('wf-start-template', ProcessStartTemplate)
Vue.component('wf-info-template', ProcessInfoTemplate)
Vue.component('wf-task-template', TaskTemplate)

Vue.config.productionTip = process.env.NODE_ENV === 'production'

Vue.prototype.rules = rules

// eslint-disable-next-line import/no-mutable-exports

const vm = new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },

  created() {
    if (window.cordova !== undefined) {
      document.addEventListener('deviceready', () => {
        // Cordova push notifications
        devicePush.init()

        // Catch back button
        document.addEventListener('backbutton', (e) => {
          e.preventDefault()
          e.stopPropagation()
          // If v-dialog is open then close it
          if (document.getElementsByClassName('v-dialog__content--active').length > 0) {
            document.getElementsByClassName('v-dialog__content--active')[0].dispatchEvent(new KeyboardEvent('keydown', { keyCode: 27 }))
            // If wf-file-downloader is open then close it
          } else if (document.querySelectorAll("div.uppy-Dashboard--modal:not([aria-hidden='true'])").length > 0) {
            document.dispatchEvent(new KeyboardEvent('keydown', { keyCode: 27 }))
            // Otherwise history back
          } else {
            this.$router.go(-1)
          }
        }, false)
      })
    } else {
      // Register service workers
      setTimeout(() => {
        registerServiceWorker({ scope: '/' })
          .then(registration => registration.update())
          .then(webPush)
          .catch((error) => {
            if (error instanceof ServiceWorkerNoSupportError) {
              console.log('ServiceWorker is not supported.')
            } else {
              console.log('Error: ', error)
            }
          })
      }, 10000)

      setTimeout(() => {
        try {
          const mif = [...document.fonts].filter(f => f.family === '"Material Icons"')
          if (mif && mif[0] && mif[0].status === 'error') {
            console.warn('Material Icons not loaded')
            const fontMDI = new FontFace('"Material Icons"', 'url(/static/fonts/MaterialIcons-Regular.woff)')
            fontMDI.load().then(() => {
              document.fonts.add(fontMDI)
            })
          }
        } catch (e) {
          console.log(e)
        }
      }, 2000)
    }
  },

  template: '<App/>',
})

export default vm



// WEBPACK FOOTER //
// ./src/main.js